import { render, staticRenderFns } from "./PlacesSelect.vue?vue&type=template&id=2da58cf4&scoped=true&"
import script from "./PlacesSelect.vue?vue&type=script&lang=js&"
export * from "./PlacesSelect.vue?vue&type=script&lang=js&"
import style0 from "./PlacesSelect.vue?vue&type=style&index=0&id=2da58cf4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da58cf4",
  null
  
)

export default component.exports